// extracted by mini-css-extract-plugin
export var checkbox = "_66-0";
export var circle = "_66-3";
export var horizontalContainer = "_66-7";
export var sm = "_66-5";
export var switch0 = "_66-2";
export var switchDisabled = "_66-8";
export var switchEnabled = "_66-1";
export var textSwitchContainer = "_66-9";
export var textSwitchOption = "_66-a";
export var textSwitchOptionSelected = "_66-b";
export var verticalContainer = "_66-6";
export var xs = "_66-4";